import { createContext, useContext, useState, ReactNode } from "react";

export type Dimension = "physical" | "emotional" | "mental" | "spiritual" | "social";

export const DIM_META: Record<Dimension, { color: string; icon: string; label: string }> = {
  physical:  { color: "#2A9D8F", icon: "💪", label: "Physical"  },
  emotional: { color: "#E76F51", icon: "🧡", label: "Emotional" },
  mental:    { color: "#457B9D", icon: "🧠", label: "Mental"    },
  spiritual: { color: "#F4A261", icon: "✨", label: "Spiritual" },
  social:    { color: "#E9C46A", icon: "🤝", label: "Social"    },
};

type Ctx = {
  active: Dimension | null;
  setActive: (d: Dimension | null) => void;
};

const SyncContext = createContext<Ctx>({ active: null, setActive: () => {} });

export function DashboardSyncProvider({ children }: { children: ReactNode }) {
  const [active, setActive] = useState<Dimension | null>(null);
  return <SyncContext.Provider value={{ active, setActive }}>{children}</SyncContext.Provider>;
}

export const useDashboardSync = () => useContext(SyncContext);
